// Hooks da camada de IA (textos de anúncio e créditos do mês).
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { AdCopyRequestBody, AdCopyResponse, AiUsageDto } from '@impulso/shared/api/ai'
import { api, ApiError } from '../../lib/api'

export const aiKeys = {
  usage: (companyId: string) => ['ai', companyId, 'usage'] as const,
}

export function useAiUsage(companyId: string, enabled = true) {
  return useQuery({
    queryKey: aiKeys.usage(companyId),
    queryFn: () => api.get<AiUsageDto>(`/companies/${companyId}/ai/usage`),
    enabled,
    staleTime: 30_000,
  })
}

export function useGenerateAdCopy(companyId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: AdCopyRequestBody) => api.post<AdCopyResponse>(`/companies/${companyId}/ai/ad-copy`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: aiKeys.usage(companyId) }),
  })
}

/** Erro de cota/plano (HTTP 402). */
export const isQuotaError = (err: unknown) => err instanceof ApiError && err.status === 402

/** IA desligada/indisponível no momento (HTTP 503). */
export const isAiUnavailable = (err: unknown) => err instanceof ApiError && err.status === 503

export function creditsText(left: number | null | undefined): string | null {
  if (left == null) return null
  if (left === 0) return 'Seus créditos de IA deste mês acabaram.'
  return `${left} ${left === 1 ? 'crédito de IA restante' : 'créditos de IA restantes'} este mês`
}
